export default __webpack_public_path__ + "static/media/full screen.540ddabc.svg";